type ActionData = {
  action: () => Promise<any>;
  resolve: (data: any) => void;
  reject: (error: Error) => void;
};
export default class ActionQueue {
  private paused = false;

  private queue: ActionData[] = [];

  private isProcessing = false;

  pushAction(action: () => Promise<any>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.queue.push({ action, resolve, reject });
      this.processActions();
    });
  }

  private processActions(): void {
    if (this.isProcessing || this.isPaused) return;
    this.isProcessing = true;
    while (this.queue.length > 0 && !this.isPaused) {
      const actionData = this.queue[0];
      this.queue.splice(0, 1);
      actionData
        .action()
        .then((response) => {
          actionData.resolve(response);
        })
        .catch((error) => {
          actionData.reject(error);
        });
    }
    this.isProcessing = false;
  }

  pause(): void {
    this.paused = true;
  }

  resume(): void {
    this.paused = false;
    this.processActions();
  }

  get isPaused(): boolean {
    return this.paused;
  }
}
